/* Vonalero Kitchen page behaviours: reveal, tabs, auto-rotating modes,
   in-view video autoplay and the sticky anchor bar. Loaded once per page. */
(function () {
  if (window.__vkInit) return;
  window.__vkInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Reveal elements as they scroll into view.
  function initReveal(root) {
    var els = root.querySelectorAll('.vk-reveal:not(.is-in)');
    if (!hasIO || reduce) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // Muted looping videos only play while visible (saves battery and data).
  function initVideos(root) {
    var vids = root.querySelectorAll('[data-vk-video] video');
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); });
    if (!hasIO) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (v.__vkManual) return;
        if (e.isIntersecting && !reduce) v.play().catch(function () {});
        else v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  // Generic tab groups: [data-vk-tabs] holds [data-vk-tab="i"] buttons and [data-vk-panel="i"] panels.
  function initTabs(root) {
    root.querySelectorAll('[data-vk-tabs]').forEach(function (group) {
      if (group.__vk) return; group.__vk = true;
      var tabs = group.querySelectorAll('[data-vk-tab]');
      var panels = group.querySelectorAll('[data-vk-panel]');
      var interval = parseInt(group.getAttribute('data-vk-autoplay') || '0', 10);
      var current = 0, timer = null;

      function show(i) {
        current = i;
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-vk-tab') === String(i);
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-vk-panel') === String(i);
          p.classList.toggle('is-active', on);
          if (on) p.removeAttribute('hidden'); else if (p.hasAttribute('data-vk-hide')) p.setAttribute('hidden', '');
        });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        if (!interval || reduce || tabs.length < 2) return;
        stop();
        timer = setInterval(function () { show((current + 1) % tabs.length); }, interval);
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { stop(); show(parseInt(t.getAttribute('data-vk-tab'), 10)); });
      });
      show(0);
      if (interval && hasIO) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
        }, { threshold: 0.3 }).observe(group);
      }
    });
  }

  // Count-up numbers: <b data-vk-count="16">16</b>
  function initCounts(root) {
    var els = root.querySelectorAll('[data-vk-count]');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-vk-count'));
      var suffix = el.getAttribute('data-vk-suffix') || '';
      if (reduce || isNaN(target)) { el.textContent = target + suffix; return; }
      var t0 = null, dur = 1400;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!hasIO) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  // UGC cards: tap to play with sound, tap again to pause.
  function initUgc(root) {
    root.querySelectorAll('.vk-ugc__card').forEach(function (card) {
      if (card.__vk) return; card.__vk = true;
      var v = card.querySelector('video');
      var btn = card.querySelector('.vk-ugc__play');
      if (!v || !btn) return;
      function toggle() {
        if (v.paused) {
          v.__vkManual = true;
          v.muted = false; v.play().catch(function () {});
          card.classList.add('is-playing');
        } else { v.pause(); card.classList.remove('is-playing'); }
      }
      btn.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
    });
  }

  // Sticky anchor bar: visible once the buy box leaves the viewport.
  function initBar() {
    var bar = document.querySelector('[data-vk-bar]');
    if (!bar) return;
    var buybox = document.querySelector('.product__info-container') || document.querySelector('.product__info-wrapper');
    if (!buybox) return;
    var btn = bar.querySelector('[data-vk-bar-buy]');
    if (btn) btn.addEventListener('click', function () {
      buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var add = buybox.querySelector('button[name="add"]');
      if (add) setTimeout(function () { add.focus({ preventScroll: true }); }, 500);
    });
    if (hasIO) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }).observe(buybox);
    }
    var priceEl = bar.querySelector('[data-vk-bar-price]');
    var source = document.querySelector('.product__info-container .price');
    if (priceEl && source && 'MutationObserver' in window) {
      var sync = function () {
        var item = source.querySelector('.price-item--sale') || source.querySelector('.price-item--regular');
        var text = (item || source).textContent.replace(/\s+/g, ' ').trim();
        if (text) priceEl.textContent = text;
      };
      sync();
      new MutationObserver(sync).observe(source, { childList: true, subtree: true, characterData: true });
    }
    // Highlight the link of the section in view.
    var links = bar.querySelectorAll('.vk-bar__links a');
    if (hasIO && links.length) {
      var map = {};
      links.forEach(function (a) { var id = a.getAttribute('href').slice(1); var t = document.getElementById(id); if (t) map[id] = a; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && map[e.target.id]) {
            links.forEach(function (a) { a.classList.remove('is-current'); });
            map[e.target.id].classList.add('is-current');
          }
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
    }
  }

  function initAll(root) {
    root = root || document;
    initReveal(root); initVideos(root); initTabs(root); initCounts(root); initUgc(root);
  }

  onReady(function () { initAll(document); initBar(); });
  // Theme editor: re-run when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initBar(); });
})();
